import React from "react";
import ReactMarkdown from "react-markdown";

export function Markdown({
  children,
  className,
}: {
  children: string;
  className?: string;
}) {
  return (
    <>
      <ReactMarkdown
        skipHtml
        className={className}
        unwrapDisallowed
        allowedElements={["code"]}
        components={{ code: InlineCode }}
      >
        {children}
      </ReactMarkdown>
    </>
  );
}

function InlineCode({ children }: { children: React.ReactNode }) {
  return (
    <>
      <code>{children}</code>

      <style jsx>{`
        code {
          /* Override default font size for code. */
          font-size: inherit;
        }
      `}</style>
    </>
  );
}
